export default [
    {
        path: "/gestion-acciones",
        name: "gestion-acciones",
        component: () =>
            import(/* webpackChunkName: "gestionAcciones" */ "../views/listaGestionAcciones.vue"),
    },
    {
        path: "/gestion-acciones/agregar",
        name: "agregar-gestion-acciones",
        component: () =>
            import(/* webpackChunkName: "agregarGestionAcciones" */ "../views/crearEditarGestionAcciones.vue"),
    },
    {
        path: "/gestion-acciones/editar/:id",
        name: "editar-gestion-acciones",
        component: () =>
            import(/* webpackChunkName: "editarGestionAcciones" */ "../views/crearEditarGestionAcciones.vue"),
    }
];